import { Box, LinearProgress } from "@material-ui/core"
const Avance = ({progress, label = true}) => {
    const progreso = (progress > 100) ? 100 : progress
    return (
        <Box sx={{ width: '100%' }}>
            <LinearProgress style={{height: "8px", borderRadius: "30px"}} variant="determinate" color='secondary' value={progreso}  />
            <p>{ (label) ? `Porcentaje: ${Math.trunc(progress)}%` : `${Math.trunc(progress)}%`}</p>
        </Box>
    )
}
export default Avance